import { render, staticRenderFns } from "./best-mobile-history.component.vue?vue&type=template&id=6f70a985&scoped=true"
import script from "./best-mobile-history.component.vue?vue&type=script&lang=js"
export * from "./best-mobile-history.component.vue?vue&type=script&lang=js"
import style0 from "./best-mobile-history.component.vue?vue&type=style&index=0&id=6f70a985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70a985",
  null
  
)

export default component.exports